// Get API keys
const YT_API_KEY = process.env.REACT_APP_YOUTUBE_KEY;
const TMDB_API_KEY = process.env.REACT_APP_TMDB_KEY;

// Check environment using custom environment variable from .env
// This allows manual switching between production and development modes
// but production should always use the YouTube API secret.
const isProduction = process.env.NODE_ENV === 'production';
const isCustomDevelopment =
  !isProduction &&
  (process.env.REACT_APP_CUSTOM_ENV === 'development' ||
    process.env.NODE_ENV === 'development');

// Channel ID for Ruch Oporników
const CHANNEL_ID = 'UCLwdi-TmEt2hQS9g6Roz69A';

// Define requests based on environment
const requests = isCustomDevelopment
  ? {
      // TMDB API endpoints for development
      fetchSpecial: `https://api.themoviedb.org/3/movie/popular?api_key=${TMDB_API_KEY}&language=pl-PL&page=1`,
      fetchLatest: `https://api.themoviedb.org/3/movie/top_rated?api_key=${TMDB_API_KEY}&language=pl-PL&page=1`,
      fetchRandom: `https://api.themoviedb.org/3/trending/movie/week?api_key=${TMDB_API_KEY}&language=pl-PL`,
      fetchAllChannelVideos: `https://api.themoviedb.org/3/movie/now_playing?api_key=${TMDB_API_KEY}&language=pl-PL&page=1`
    }
  : {
      // YouTube API endpoints for production
      fetchSpecial: `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=100&playlistId=PLAgaDn19X_evTJXqdcZzkeY1F91hYsEMU&fields=items%2Fsnippet(title%2Cdescription%2Cthumbnails(standard%2Cmaxres)%2CresourceId(videoId)%2CpublishedAt)&key=${YT_API_KEY}`,
      // Fetch from "Najnowsze" playlist - curated latest videos
      fetchLatest: `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=100&playlistId=PLAgaDn19X_ev_JMLCbQkDYlOXGbQOTRla&fields=items%2Fsnippet(title%2Cdescription%2Cthumbnails(standard%2Cmaxres)%2CresourceId(videoId)%2CpublishedAt)&key=${YT_API_KEY}`,
      fetchRandom: `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=100&playlistId=PLAgaDn19X_etRzIRsivMKWLUN7TeToKl8&fields=items%2Fsnippet(title%2Cdescription%2Cthumbnails(standard%2Cmaxres)%2CresourceId(videoId)%2CpublishedAt)&key=${YT_API_KEY}`,
      // Search all videos from the entire channel (up to 100 videos, ordered by date)
      fetchAllChannelVideos: `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${CHANNEL_ID}&type=video&maxResults=100&order=date&key=${YT_API_KEY}`,
    };

export default requests;
